<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option v-if="mostrarTodos" value=""> Todos </option>
      <option v-else disabled selected value=""> Selecione </option>
      <option
        v-for="v in valores"
        :key="v[chave]"
        :selected="v[descricao] === valor"
        :value="v[descricao]"
      >
        {{ v[descricao] }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'
import { dominioMixin } from '@/mixins/DominioMixin'

export default {
  name: 'SelecionarDominio',
  mixins: [campoMixin, dominioMixin],
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    dominio: {
      type: String,
      required: true,
    },
    chave: {
      type: String,
      default: '_id',
    },
    descricao: {
      type: String,
      default: 'valor',
    },
  },
  data() {
    return {
      valores: [],
    }
  },
  created() {
    this.recuperarValoresDominio(this.dominio).then((res) => {
      this.valores = res.valores
    })
  },
}
</script>
